//import node_modules
import React from "react";
import { NextPage } from "next";

//layout
import BlogLayout, { BlogLayoutProps } from "@adjust/website/src/layouts/BlogLayout";

//components
import SizedContainer from "@adjust/website/src/components/SizedContainer";
import Typography from "@adjust/website/src/components/Typography";
import TypographyContainer from "@adjust/website/src/components/TypographyContainer";
import BlogImage from "@adjust/website/src/components/BlogImageComponent";

import image from "@adjust/public/images/d522818833a6d5f9a5eb481462050e9ba2096072.webp";

const BlogPage: NextPage<BlogLayoutProps> = ({ blog, recommendations }) => {
  return (
    <BlogLayout blog={blog} recommendations={recommendations}>
      <SizedContainer size="sm">
        <TypographyContainer>
          <Typography type="heading-one" textAlign="center">
            Do I Need a Passport and How Do I Get One?
          </Typography>
        </TypographyContainer>
        <BlogImage src={image} alt={"Picture of Passport"} objectFit="cover" priority />
        <TypographyContainer>
          <Typography type="paragraph">YES! You will need a passport if you are flying internationally and if you are cruising to and from foreign ports.</Typography>
          <Typography type="paragraph">
            Passports are required for U.S. citizens whose cruise embarks or disembarks in a foreign country, including Canada. In addition, passports are required for sailings
            that begin and end in different U.S. ports. There are certain shore excursions that require a passport for day trips to smaller Caribbean islands and in Alaska to do
            the White Pass and Yukon Railway train ride. It is also a good idea to verify the individual ports’ entry requirements, because you might need to obtain a visa.
          </Typography>
          <Typography type="paragraph">
            So the first step in planning your next getaway is making sure you have proper documentation to travel abroad. Let’s talk about how to apply for a passport?
          </Typography>
          <Typography type="paragraph">
            My best advice is to apply early! Apply for your passport several months before your trip and know your expiration date. If you live in Raleigh, NC you can call (919)
            420-5343 to schedule an appointment at one of the post offices.
          </Typography>
          <Typography type="paragraph">Passport processing can take about 6-8 weeks unless you pay to have an expedited service for an additional $60 dollars.</Typography>
          <Typography type="paragraph">
            Visit the government’s website http://www.usa.gov/passport to get the application and the latest information about cost. You can also call the US Passport Service Guide
            at 1-877-487-2778 to speak with a customer service representative.
          </Typography>
          <Typography type="paragraph">
            Once you’ve completed the application, locate a local passport acceptance facility which can be a post office, some public libraries or clerk of court office. Be aware
            that many acceptance facilities have limited operating hours and require an appointment so be sure to call before going.
          </Typography>
          <Typography type="paragraph">
            Passport applications take 4 to 6 weeks to process unless you request expedited service. Then, it takes 2 to 3 weeks. Some facilities require an appointment or have
            limited hours so do your homework ahead of time before dropping by.
          </Typography>
          <Typography type="paragraph">
            In North Carolina the fee for a passport is $110 for adults plus a $60 execution fee and for children younger than 16 years old $80 plus the $60 execution fee.
          </Typography>
          <Typography type="paragraph">
            If your passport hasn’t already expired you can renew your passport by mail using application DS-82 if you meet the criteria listed on the U.S. Department of State web
            site;
          </Typography>
          <Typography type="bulleted-list">
            <Typography type="list-item">Your passport is not significantly damaged and can be submitted with the application</Typography>
            <Typography type="list-item">It was issued when you were age 16 or older</Typography>
            <Typography type="list-item">It was issued within the past 15 years</Typography>
            <Typography type="list-item">It was issued in your current name or you can legally document your name change</Typography>
          </Typography>
          <Typography type="paragraph">
            There are few supporting documents that are required. First of all, you must send your most recent valid or expired passport. Your passport will be invalidated and
            returned to you. If it is damaged or mutilated in any way, you cannot use this form but, rather, must appear in person to apply. You also need to submit a recent
            passport photo that has dimensions of 2 inches by 2 inches.
          </Typography>
          <Typography type="paragraph">
            Applicants whose names have been legally changed need to submit evidence of this fact. Acceptable documents to prove a legal name change include a marriage certificate,
            divorce decree, adoption certificate or court order. The document you submit must be an original or a certified copy. It will be returned to you.
          </Typography>
          <Typography type="paragraph">
            If you do not meet the criteria, you cannot apply to renew your passport by mail. You need to submit the application for a new U.S. passport utilizing the Form DS-11
            and supporting documents in person at an application acceptance facility.
          </Typography>
          <Typography type="paragraph">How much does it cost to get a passport in North Carolina?</Typography>
          <Typography type="paragraph">
            Payment for the passport (only) fee of either $110 (adult) plus a $60 execution fee, or $80 (younger than 16 years old) plus a $60 execution fee. Payment for the
            passport card (and book) fee of either $140 (adult) plus a $60 execution fee, or $95 (younger than 16 years old) plus a $60 execution fee.
          </Typography>
          <Typography type="paragraph">
            To enter the United States at land border crossings or sea ports-of-entry from Canada, Mexico, the Caribbean, and Bermuda, you can use a passport book or a passport
            card. A passport card is more convenient and less expensive than a passport book, but it cannot be used for international travel by air.
          </Typography>
          <Typography type="paragraph">You can renew your current or expired U.S. passport unless your passport was:</Typography>
          <Typography type="bulleted-list">
            <Typography type="list-item">Issued before your 16th birthday</Typography>
            <Typography type="list-item">Issued 15 or more years ago</Typography>
            <Typography type="list-item">Damaged, lost, or stolen</Typography>
            <Typography type="list-item">Issued in your previous name and you don’t have a legal document like a marriage license to prove your legal name change</Typography>
          </Typography>
          <Typography type="paragraph">
            Need to get a passport quickly in two weeks or less, then you will need to have your passport renewal expedited and pay additional fees. Start by calling the National
            Passport Information Center to make an appointment at a Regional Passport Agency. For an automated appointment system available 24 hours a day, call 1-877-487-2778.
          </Typography>
          <Typography type="paragraph">At your appointment, you’ll need to provide proof of immediate travel, and pay an expedited fee.</Typography>
          <Typography type="paragraph">
            All children must apply or reapply for a U.S. passport in person at a passport agency and must be accompanied by BOTH parents! Children under 16 need parental consent
            and their parents must be present with their children and co-sign the application.
          </Typography>
          <Typography type="paragraph">
            Children ages 16-17 applying for a passport can do it by themselves if they have their own identification documents. However, it is recommended that at least one parent
            appears in person with the child to show parental awareness.
          </Typography>
          <Typography type="paragraph">Hope this gives you some good guidelines for beginning your vacation plans.</Typography>
        </TypographyContainer>
      </SizedContainer>
    </BlogLayout>
  );
};

export default BlogPage;
